module.exports = __webpack_public_path__ + "static/media/table-chart-24px.7cdfc509.svg";